import { GLOBAL_VARS } from '~/config/index';
import { DOUBLECLICK_SLOTS as slots, SIZE_BANNERS as sizeBanner } from './config';

const { GOOGLE_PUBLISHER_TAG_ID: GPT_ID } = GLOBAL_VARS;
const FIRST_BANNER_MINI_HERO = slots.CST_MINI_BANNER_LEFT;
const SECOND_BANNER_MINI_HERO = slots.CST_MINI_BANNER_RIGHT1;
const THIRD_BANNER_MINI_HERO = slots.CST_MINI_BANNER_RIGHT2;
const FOURTH_BANNER_MINI_HERO = slots.CST_MINI_BANNER_RIGHT3;
const FIFTH_BANNER_MINI_HERO = slots.CST_MINI_BANNER_RIGHT4;
const SIXTH_BANNER_MINI_HERO = slots.CST_MINI_BANNER_RIGHT5;

export default [
    {
        id: FIRST_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${FIRST_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: FIRST_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
    {
        id: SECOND_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${SECOND_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: SECOND_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
    {
        id: THIRD_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${THIRD_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: THIRD_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
    {
        id: FOURTH_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${FOURTH_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: FOURTH_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
    {
        id: FIFTH_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${FIFTH_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: FIFTH_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
    {
        id: SIXTH_BANNER_MINI_HERO,
        path: `/${GPT_ID}/${SIXTH_BANNER_MINI_HERO}`,
        size: sizeBanner.MINI_HERO,
        domId: SIXTH_BANNER_MINI_HERO,
        plugStaticBlock: true,
    },
];
